import {
  apiGetSharedPresentation,
  apiCopyPresentation
} from '../../common/api/lesson'

const fetchSharedPresentation = id => ({
  requestPrefix: 'SHARED_PRESENTATION:FETCH',
  params: { id },
  request: () =>
    apiGetSharedPresentation(id, {
      include:
        'shared_presentation.presentation.image,shared_presentation.presentation.year_groups,shared_presentation.presentation.year_group.order,shared_presentation.presentation.details,shared_presentation.presentation.names,shared_presentation.presentation.slides,shared_presentation.presentation.slide.details,shared_presentation.presentation.slide.type,shared_presentation.details'
    })
})

const copyPresentation = presentationId => ({
  requestPrefix: 'SHARED_PRESENTATION:COPY',
  params: { presentationId },
  request: () => apiCopyPresentation(presentationId)
})

export { fetchSharedPresentation, copyPresentation }
